module.exports = __webpack_public_path__ + "static/media/bethany-optimised.d4f50e9f.jpg";